exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttons-preview[data-v-6732915e] {\n  margin-top: 8px;\n  position: relative;\n  margin-bottom: 8px;\n  max-width: 360px;\n}\n[data-v-6732915e] .go-carousel--no-scroll {\n  margin-top: -8px;\n  margin-bottom: -8px;\n}\n.buttons-preview--vertical[data-v-6732915e] {\n  align-items: flex-end;\n  flex-direction: column;\n  margin: 0;\n}\n.single-button--vertical.single-button[data-v-6732915e] {\n  margin-left: 80px;\n  margin-top: 2px;\n  margin-bottom: 2px;\n  width: fit-content;\n}\n", ""]);

// exports
